import React, { useState } from "react";

const TermsConditions = () => {
  const [accepted, setAccepted] = useState(false);

  const handleCheckboxChange = () => {
    setAccepted(!accepted);
  };

  const handleSubmit = () => {
    if (accepted) {
      alert("Thank you for accepting the terms and conditions!");
    } else {
      alert("Please accept the terms and conditions to proceed.");
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen  mt-16">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl flex flex-col">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-bold text-gray-800">Terms and Conditions</h2>
        </div>
        
        <div className="p-6 overflow-y-auto flex-grow">
          <h3 className="text-lg font-semibold mb-3">1. Introduction</h3>
          <p className="mb-4 text-gray-700">
            Welcome to our service. These Terms and Conditions govern your use of our website,
            products, and services. By accessing or using our services, you agree to be bound
            by these Terms. If you disagree with any part of the terms, you may not access the service.
          </p>
          
          <h3 className="text-lg font-semibold mb-3">2. User Accounts</h3>
          <p className="mb-4 text-gray-700">
            When you create an account with us, you must provide information that is accurate,
            complete, and current at all times. Failure to do so constitutes a breach of the Terms,
            which may result in immediate termination of your account on our service.
          </p>
          
          <h3 className="text-lg font-semibold mb-3">3. Privacy Policy</h3>
          <p className="mb-4 text-gray-700">
            Your privacy is important to us. It is our policy to respect your privacy regarding any
            information we may collect from you across our website. We will only collect and use
            information in ways that are useful to you and consistent with your privacy rights.
          </p>
          
          <h3 className="text-lg font-semibold mb-3">4. Content</h3>
          <p className="mb-4 text-gray-700">
            Our service allows you to post, link, store, share and otherwise make available certain
            information, text, graphics, videos, or other material. You are responsible for the content
            you post and its legality, reliability, and appropriateness.
          </p>
          
          <h3 className="text-lg font-semibold mb-3">5. Termination</h3>
          <p className="mb-4 text-gray-700">
            We may terminate or suspend your account immediately, without prior notice or liability,
            for any reason whatsoever, including without limitation if you breach the Terms.
          </p>
          
          <h3 className="text-lg font-semibold mb-3">6. Limitation of Liability</h3>
          <p className="mb-4 text-gray-700">
            In no event shall we be liable for any indirect, incidental, special, consequential or
            punitive damages, including without limitation, loss of profits, data, use, goodwill, or
            other intangible losses, resulting from your access to or use of or inability to access
            or use the service.
          </p>
          
          <h3 className="text-lg font-semibold mb-3">7. Governing Law</h3>
          <p className="mb-4 text-gray-700">
            These Terms shall be governed and construed in accordance with the laws applicable in your
            jurisdiction, without regard to its conflict of law provisions.
          </p>
          
          <h3 className="text-lg font-semibold mb-3">8. Changes to Terms</h3>
          <p className="mb-4 text-gray-700">
            We reserve the right, at our sole discretion, to modify or replace these Terms at any time.
            What constitutes a material change will be determined at our sole discretion.
          </p>
        </div>
        
        {/* <div className="p-4 border-t flex justify-end space-x-4">
          <button 
            onClick={onClose}
            className="px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-100"
          >
            Decline
          </button>
          <button 
            onClick={() => {
              onAccept();
              onClose();
            }}
            className="px-4 py-2 text-white bg-orange-600 rounded-md hover:bg-orange-700"
          >
            Accept
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default TermsConditions;
